import { render, staticRenderFns } from "./SettingPromotionLocalProductDashboard.vue?vue&type=template&id=e21cedac&"
import script from "./SettingPromotionLocalProductDashboard.vue?vue&type=script&lang=js&"
export * from "./SettingPromotionLocalProductDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports